import { ItemJob } from "../models/sales";

export const getNextNumberOfItemsJob = (itemsJob?: ItemJob[]): number => {
  let maxItemNumber = 0;

  if (itemsJob && itemsJob?.length) {
    for (const itemJob of itemsJob) {
      if (itemJob?.number && itemJob.number > maxItemNumber) {
        maxItemNumber = itemJob.number;
      }
    }
  }

  return maxItemNumber + 1;
};
